// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1iCeK","text":"styles_text__3ts5C","buttons":"styles_buttons__3fUyh"};